function normalizeText(value) {
  return value === undefined || value === null ? '' : String(value);
}

var KNOWLEDGE_START = '<!-- ALLEFLOW_KNOWLEDGE_ITEMS_START -->';
var KNOWLEDGE_END = '<!-- ALLEFLOW_KNOWLEDGE_ITEMS_END -->';

// Preset knowledge-item categories. The first is the default when none is set
// (e.g. legacy items saved before categories existed).
var KNOWLEDGE_CATEGORIES = ['API Docs', 'Credentials', 'Business Rules', 'Domain Notes', 'Other'];
var DEFAULT_CATEGORY = KNOWLEDGE_CATEGORIES[0];

// Coerce any stored value to a known category, falling back to the default.
function normalizeCategory(value) {
  var v = normalizeText(value).trim();
  for (var i = 0; i < KNOWLEDGE_CATEGORIES.length; i += 1) {
    if (KNOWLEDGE_CATEGORIES[i].toLowerCase() === v.toLowerCase()) return KNOWLEDGE_CATEGORIES[i];
  }
  return DEFAULT_CATEGORY;
}

function sanitizeKnowledgeItems(items) {
  return (Array.isArray(items) ? items : []).map(function(item, index) {
    var entry = item && typeof item === 'object' ? item : {};
    return {
      id: entry.id ? String(entry.id) : 'knowledge-' + index,
      title: normalizeText(entry.title).trim(),
      category: normalizeCategory(entry.category),
      context: normalizeText(entry.context).trim()
    };
  }).filter(function(item) {
    return item.title || item.context;
  });
}

function parseKnowledgeBlock(block) {
  var text = normalizeText(block).trim();
  if (!text) return [];

  text = text.replace(/^##\s*Knowledge Items\s*/i, '').trim();
  if (!text) return [];

  var sections = text.split(/\n(?=###\s+)/);
  var items = [];

  for (var i = 0; i < sections.length; i += 1) {
    var section = String(sections[i] || '').trim();
    if (!section) continue;

    var match = section.match(/^###\s*(.+?)\s*(?:\n+([\s\S]*))?$/);
    if (!match) continue;

    // The heading may carry a trailing "[category: X]" tag. Pull it off the
    // title so it isn't shown as part of the title text; default if absent.
    var rawTitle = normalizeText(match[1]).trim();
    var category = DEFAULT_CATEGORY;
    var catMatch = rawTitle.match(/\s*\[category:\s*([^\]]+)\]\s*$/i);
    if (catMatch) {
      category = normalizeCategory(catMatch[1]);
      rawTitle = rawTitle.slice(0, catMatch.index).trim();
    }

    items.push({
      id: 'knowledge-' + i,
      title: rawTitle,
      category: category,
      context: normalizeText(match[2]).trim()
    });
  }

  return sanitizeKnowledgeItems(items);
}

function parseAiInstructionDocument(value) {
  var text = normalizeText(value);
  var startIndex = text.indexOf(KNOWLEDGE_START);
  var endIndex = text.indexOf(KNOWLEDGE_END);

  if (startIndex < 0 || endIndex < startIndex) {
    return {
      general: text.trim(),
      items: []
    };
  }

  var general = text.slice(0, startIndex).trim();
  var knowledgeBlock = text.slice(startIndex + KNOWLEDGE_START.length, endIndex).trim();

  return {
    general: general,
    items: parseKnowledgeBlock(knowledgeBlock)
  };
}

function serializeAiInstructionDocument(input) {
  var data = input && typeof input === 'object' ? input : {};
  var general = normalizeText(data.general).trim();
  var items = sanitizeKnowledgeItems(data.items);
  var sections = [];

  if (general) {
    sections.push(general);
  }

  if (items.length) {
    var knowledgeLines = ['## Knowledge Items'];
    for (var i = 0; i < items.length; i += 1) {
      // Encode the category as a trailing tag on the heading so it persists and
      // stays human-readable: "### Title [category: API Docs]".
      knowledgeLines.push('### ' + items[i].title + ' [category: ' + normalizeCategory(items[i].category) + ']');
      knowledgeLines.push(items[i].context || '');
    }
    sections.push(
      KNOWLEDGE_START + '\n' +
      knowledgeLines.join('\n\n') + '\n' +
      KNOWLEDGE_END
    );
  }

  return sections.join('\n\n').trim();
}

module.exports = {
  parseAiInstructionDocument: parseAiInstructionDocument,
  serializeAiInstructionDocument: serializeAiInstructionDocument,
  KNOWLEDGE_CATEGORIES: KNOWLEDGE_CATEGORIES,
  DEFAULT_CATEGORY: DEFAULT_CATEGORY
};
